import { Injectable } from "@angular/core";
import { DateTime } from "luxon";

@Injectable()
export class DateService {
  isAfter(isoDateLeft: string, date: string): boolean {
    return DateTime.fromISO(isoDateLeft) > DateTime.fromISO(date);
  }

  add(date: string, value: number, unit: "days" | "months" | "years") {
    return DateTime.fromISO(date).plus({ [unit]: value });
  }
}
